<template>
  <div id="app">
    <Loading v-show="axiosLoading"></Loading>
    <transition name="fadeIn">
      <router-view />
    </transition>
    <!--提示框dialog -->
    <!-- <mu-dialog :title="dialog.confirmTitle" :esc-press-close="false" :overlay-close="false" :open="dialog.confirm" >
      {{dialog.confirmContent}}
      <mu-button slot="actions" flat color="#b19cfb" @click="toCloseSimpleDialog" primary>{{dialog.confirmId?"取消":"确认"}}</mu-button>
      <mu-button slot="actions" flat color="#718ffe" v-if="dialog.confirmId" @click="confirmOk" >确认</mu-button>
    </mu-dialog> -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { mapState } from "vuex";
import { mapActions } from "vuex";
import Loading from "./components/loading";
export default {
  components: {
    Loading,
  },
  data() {
    return {};
  },
  methods: {
    // ...mapActions(["closeSimpleDialog","sureSimpleDialog"]),
    // toCloseSimpleDialog() {
    //   this.closeSimpleDialog();
    // },
    // confirmOk() {
    //   this.sureSimpleDialog();
    // },
  },
  computed: {
    ...mapGetters(["axiosLoading"]),
    // ...mapState({
    //   dialog:state=>state.dialog.dialog
    // }),
  },
};
</script>






// WEBPACK FOOTER //
// src/App.vue